(() => {
  const initializeContactForm = (form) => {
    if (!form || form.dataset.twomatoesContactReady === 'true') return;

    const submitButton = form.querySelector('[data-contact-submit]');
    const defaultContent = form.querySelector('[data-contact-submit-default]');
    const loadingContent = form.querySelector('[data-contact-submit-loading]');

    if (!submitButton || !defaultContent || !loadingContent) return;

    const setLoading = (loading) => {
      submitButton.disabled = loading;
      submitButton.setAttribute('aria-busy', loading ? 'true' : 'false');
      submitButton.classList.toggle('is-loading', loading);
      defaultContent.hidden = loading;
      loadingContent.hidden = !loading;
    };

    form.addEventListener('submit', () => {
      if (!form.checkValidity()) return;
      setLoading(true);
    });

    window.addEventListener('pageshow', () => setLoading(false));
    form.dataset.twomatoesContactReady = 'true';
  };

  const initializeContactForms = (scope = document) => {
    scope.querySelectorAll('[data-twomatoes-contact-form]').forEach(initializeContactForm);
  };

  document.addEventListener('DOMContentLoaded', () => initializeContactForms());
  document.addEventListener('shopify:section:load', (event) => initializeContactForms(event.target));
})();
